import axios from "axios";
import { getCookie } from "@fe_utils/fe_sdk_base";

axios.defaults.withCredentials = true;
axios.interceptors.request.use(
  function (config) {
    const qz_client = getCookie('qz-client') || '';
    config.headers["qz-client"] = qz_client;
    // config.headers["qz-token"] = 'T:9116ca942f4e489cb28cf695442f24f0:HY';//maimen
    // config.headers['qz-package'] = common.getCookie('qz-package');
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);
// 预订单接口
export async function getOrderNoByGoodId(_data) {
  const url = `${process.env.REACT_APP_API_URL}/goods/order/preorder/raw`;
  let { state, data } = await axios.post(url, _data);
  return await data;
}
// 下单接口
export async function getOrderRaw(_data) {
  const url = `${process.env.REACT_APP_API_URL}/goods/order/raw`;
  let { state, data } = await axios.post(url, _data);
  return await data;
}

export async function getPayBillStatus(orderNo, params) {
  const url = `${process.env.REACT_APP_API_URL}/goods/order/${orderNo}/status`;
  let { data } = await axios.get(url, { params });
  return await data;
}